<kpa-audit
	[dialogOpened]="isAudit"
	[scheduledAuditId]="currentAuditId"
	[progress]="auditProgress"
	[questionCollection]="auditQuestionCollection"
	(closeDialog)="closeDialog()"
	[defaultQuestionPerPage]="defaultQuestionPerPage"
	(paginationChange)="onPageActionChange($event)"
	(onItemPerPageChange)="updateItemsPerPage($event)"
	(submitAudit)="submitAudit($event)"
	[currentQuestionNumber]="currentQuestion"
	[perPageQuestionIds]="perPageQuestionIds"></kpa-audit>
